<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { authComputed } from "@/state/helpers";

// Custom Component

import BookingService from "@/helpers/APIService/booking.service";
import errorHandler from "@/helpers/errorHandler";

export default {
  page: {
    title: "Booking Audit",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      title: "Night Audit",
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 50,
        total_pages: 1,
        page_number: 1,
        per_page: 100,
        from: 1,
        to: 100,
      },
      isDataLoading: true,
    };
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  mounted() {
    this.getNightAuditListData();
  },
  methods: {
    // Method is use for get booking list data
    async getNightAuditListData() {
      this.isDataLoading = true;
      await BookingService.getNightAuditList()
        .then((response) => {
          if (response.results != null && response.results.length > 0) {
            this.table.tableData = response.results;
          }
          this.table.next = response.next;
          this.table.previous = response.previous;
          this.table.count = response.count;
          this.table.total_pages = response.total_pages;
          this.table.page_number = response.page_number + 1;
          this.table.from = response.from;
          this.table.to = response.to;
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.isDataLoading = false;
      this.busy = false;
    },
    //  Method is use for redirect user to start night audit
    startNewDayAudit() {
      this.$router.push({ path: "/booking/audit/night" });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      title="Night Audit List"
      :action="startNewDayAudit"
      text="Start New Day Audit"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="table-responsive mb-0" v-dragscroll>
              <table
                class="table table-hover mb-0"
                ref="my-table"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="10"
              >
                <thead class="table-light">
                  <tr>
                    <th>Audit Date</th>
                    <th>Next Audit Date</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>InHouse</th>
                    <th>Stay Guest</th>
                    <th>No Show</th>
                    <th>Extend</th>
                    <th>House Keeping Task</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody
                  id="infinite-list"
                  v-if="table.tableData.length > 0 && !isDataLoading"
                >
                  <tr v-for="data in table.tableData" :key="data.reference_no">
                    <td>{{ global_format_date(data.audit_date) }}</td>
                    <td>{{ global_format_date(data.next_audit_date) }}</td>
                    <td>{{ data.check_in }}</td>
                    <td>{{ data.check_out }}</td>
                    <td>{{ data.total_in_house }}</td>
                    <td>{{ data.total_stay_guest }}</td>
                    <td>{{ data.no_show }}</td>
                    <td>{{ data.extend }}</td>
                    <td>{{ data.house_keeping }}</td>
                    <td>{{ data.created_by }}</td>
                  </tr>
                </tbody>
                <tbody v-if="isDataLoading">
                  <tr v-for="number in 20" :key="number">
                    <td class="placeholder-glow" v-for="no in 10" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!isDataLoading && table.tableData.length == 0">
                  <tr>
                    <td colspan="12" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
